import * as React from 'react';
import DSIconSearch from '@lmig/design-system-icons-react/_cjs/system/Search';
import IconWrapper from '../IconWrapper';

/** @no-props */
var IconSearch = function IconSearch(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement(DSIconSearch, null));
};
export default IconSearch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/lmds-react-icons/dist/_esm/icons/Search.js
// module id = 2445
// module chunks = 0